var map = {
	"./browser-end-dark.png": 11403,
	"./browser-end-light.png": 32636,
	"./browser-repeat-dark.png": 57914,
	"./browser-repeat-light.png": 76422,
	"./browser-start-dark.png": 88581,
	"./browser-start-light.png": 88353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93098;